import { set, toggleMenu, toggleMenuCaptions } from "../actions/types"

const INITIAL_STATE = {
  isMenuVisible: true,
  areMenuCaptionsVisible: false,
}

export default function reducer(state = INITIAL_STATE, action) {
  switch (action.type) {
    case set:
      return {
        ...state,
        [action.key]: action.value,
      }
    case toggleMenu:
      return {
        ...state,
        isMenuVisible: !state.isMenuVisible,
      }
    case toggleMenuCaptions:
      return {
        ...state,
        areMenuCaptionsVisible: !state.areMenuCaptionsVisible,
      }
    default:
      return state
  }
}
